<div>
  <div>

    <div class="modal-header customBlueHeader">
      <p class="modal-title">Prescription Upload</p>
      <button type="button" aria-label="Close" class="close" (click)="closePopup()">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <!-- <div class="succMsg" *ngIf="isReportUploaded">Prescription Uploaded Successfully</div> -->
    <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
    <div class="modal-body">
      <form [formGroup]="uploadForm" (ngSubmit)="onSubmit(order_id)">
        <div class="flexBetween">
          <input type="file" name="profile" (change)="onFileSelect($event)"
            *ngIf="isPrescriptionUploadReportBtn" #imageInput/>
          <button type="submit" class="upload_btn green_btn" *ngIf="isPrescriptionUploadReportBtn">Upload</button>
          <!-- <button type="submit" class="upload_btn green_btn" *ngIf="isUploadReportButton">Upload</button> -->
        </div>
      </form>

      <div *ngIf="sendPrescriptionLink" class="prescription_btn_box"
        (click)="openBackDropCustomClass(prescriptionUploadModal)"> &nbsp;<a class="prescription_btn"> <img
            class="presripImg" src="./assets/img/share-square-solid-blue.png">Send Prescription Link</a></div>

      <div>

        <button type="button" class="upload_btn green_btn upload-finish-btn" *ngIf="isPrescriptionUploadReportBtn"
          (click)="prescriptionUploadCompleted(order_id)">
          Prescription Upload Completed
        </button>
      </div>
      <div class="mrg-tp-15">
        <table class="table table-striped table-responsive table-hover uploadedRecordTable">
          <thead>
            <tr>
              <th class="width100p">Uploaded Prescription Records</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let document of documents">
              <td class="view_btn" *ngIf="document.documentType=='prescription'">{{document.documentName}}</td>
              <td class="view_btn" *ngIf="document.documentType=='prescription'"
                (click)="download(document.documentId)"><a>Download</a></td>
              <td class="view_btn" *ngIf="document.documentType=='prescription' && isDelete"
                (click)="delete(document.documentId,document.documentName)"><a>Delete</a></td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  <ng-template #prescriptionUploadModal let-modal>
    <div class="modal-header customBlueHeader">
      <p class="modal-title">Prescription Upload</p>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <ng-container *ngIf="!isPrescriptionSend">
      <div class="modal-body customModalBody">
        <p class="marB15">Dear Customer please upload prescription through this link.</p>

        <!-- <a href="#">www.prescriptionuploadhere.com/payments</a> -->
      </div>
      <div class="modal-footer customModalFooter" *ngIf="sendPrescriptionLink">

        <button type="button" class="btn btn-light" (click)="sendPrescriptionUrl()">Send</button>
      </div>
    </ng-container>
    <ng-container *ngIf="isPrescriptionSend">
      {{prescriptionResponse}}

      <div class="modal-footer customModalFooter">
        <button type="button" class="btn green_btn" (click)="modal.close('Close click')">Close</button>


      </div>
    </ng-container>
  </ng-template>

</div>